module.exports = __webpack_public_path__ + "static/bvaughn-tearing-2-c90e02c539efbfb00bf4fee6abe2019e.png";